import { useState } from 'react';
import PowerBiMainProductGroupModel from '../product/PowerBiMainProductGroup';

const MinMaxSettingsModel = () => {
  const initialState = {
    id: 0,
    mainProductGroup: PowerBiMainProductGroupModel().initialState,
    productType: '',
    min: new Number(),
    max: new Number(),
  };
  const [minMaxSettings, setMinMaxSettings] = useState(initialState);

  const resetMinMaxSettings = () => {
    setMinMaxSettings(initialState);
  };
  return {
    minMaxSettings,
    setMinMaxSettings,
    resetMinMaxSettings,
    initialState,
  };
};

export default MinMaxSettingsModel;
